<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">Autorización Negociación</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="6">
                            <div class="mt-2">
                                <h4 style="color :#2196f3">Movimiento: </h4>
                                <p class="type-text-style">Dar Respuesta a la Negociación</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <v-col cols="12" md="5">
                                <h4 style="color :#2196f3">Vamos a: </h4>
                                <v-radio-group v-model="tipoNegociacion" style="margin: -1px; margin-left: 15px;">
                                    <v-radio :label="datos.tipoNegociacionname" value="1"></v-radio>
                                </v-radio-group>
                            </v-col>

                            <v-divider class="mt-1"></v-divider>

                            <div v-if="datos.responsabilidadname != ''">
                                <div class="mt-2">
                                    <span style="font-size:16px">Responsabilidad por parte de conformidad al criterio
                                        del ajustador, el responsable es:</span>
                                    <v-radio-group v-model="datos.responsabilidadAse"
                                        style="margin: -1px; margin-left: 15px;">
                                        <v-radio :label="datos.responsabilidadname" value="1"></v-radio>
                                    </v-radio-group>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                            </div>

                            <div class="mt-2">
                                <span style="font-size:16px">Estimado de daños NA:</span>
                                <p class="type-text-style">{{ datos.montoestimadodanos }}</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Monto de Negociación:</span>
                                <v-text-field v-model="datos.montoneg" outlined dense disabled filled></v-text-field>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Responsabilidad de acuerdo con el documento
                                    soporte:</span>
                                <v-text-field v-model="datos.responsabilidad" outlined dense disabled
                                    filled></v-text-field>
                            </div>

                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-2">
                                <span style="font-weight: bold;">Monto de acuerdo con el documento soporte:</span>
                                <v-text-field v-model="datos.montoacuerdo" outlined dense disabled
                                    filled></v-text-field>
                            </div>

                            <v-divider class="mt-1"></v-divider>


                            <div class="mt-2">
                                <span style="font-weight: bold;">¿Acepta la negociación propuesta?:</span>
                                <v-radio-group row v-model="datos.respneg" :rules="rulesradios" inline
                                    style="margin: -1px; margin-left: 2px;">
                                    <v-radio label="Sí" value="1"></v-radio>
                                    <v-radio label="No" value="0"></v-radio>
                                </v-radio-group>
                            </div>
                            <v-divider class="mt-1"></v-divider>


                            <div v-if="datos.respneg == '1'">
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Quién Autorizo (Aseguradora - Nombre y
                                        Apellido):</span>

                                    <v-textarea @input="uppercase('observacionesAutoriza')"
                                        v-on:blur="datos.observacionesAutoriza = datos.observacionesAutoriza != null ? datos.observacionesAutoriza.trim() : null"
                                        :counter="$store.state.maxLengthComentarios"
                                        :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined
                                        rows="3" v-model="datos.observacionesAutoriza"></v-textarea>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                                <span style="font-weight: bold;">Forma de Recuperación / pago:</span>
                                <v-select outlined :rules="rulesselect" dense :items="formaArray"
                                    v-model="datos.formaRecuperacion" item-text="label" item-value="value"
                                    placeholder="Seleccione Responsabilidad" return-object>

                                </v-select>
                                <v-divider class="mt-1"></v-divider>
                            </div>

                            <div v-if="datos.respneg == '0'">
                                <div class="mt-2">
                                    <span style="font-weight: bold;">Monto / rango aseguradora:</span>
                                    <v-text-field v-model="datos.montorango" outlined
                                        placeholder="Ejemplo: 15000/20000 ó 15000" dense :rules="rulesMontoAse"
                                        @keypress="ruleMoney($event, datos.montorango)"></v-text-field>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                            </div>



                            <div class="mt-2">
                                <span style="font-weight: bold;">Fecha de respuesta de la negociación:</span>
                                <v-dialog ref="dialog" outlined v-model="modal"
                                    :return-value.sync="datos.fecharespuesta" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="date-align-center">
                                            <v-text-field v-model="fechaResp" label="" readonly :rules="rulestextfechas"
                                                outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="datos.fecharespuesta" locale="es-mx" :max="maxDate"
                                        :min="minDate" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="modal = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.dialog.save(datos.fecharespuesta)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </div>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-2">
                                <span style="font-weight: bold;">Firma Electrónica Avanzada:</span>
                                <v-text-field solo
                                    v-on:blur="datos.firma = datos.firma != null ? datos.firma.trim() : null" dense
                                    hide-details style="-webkit-text-security: disc;" maxlength="17"
                                    v-model="datos.firma">
                                </v-text-field>
                                <div v-if="errorFirma">
                                    <span class='spanError' style="color:red;font-size:12px">{{ messageFirma }}</span>
                                    <br />
                                </div>
                            </div>


                            <v-divider class="mt-4"></v-divider>

                            <div class="mt-2">

                                <span style="font-weight: bold;">Observaciones</span>
                                <v-textarea @input="uppercase('observaciones')"
                                    v-on:blur="datos.observaciones = datos.observaciones != null ? datos.observaciones.trim() : null"
                                    :counter="$store.state.maxLengthComentarios"
                                    :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined
                                    rows="3" v-model="datos.observaciones"></v-textarea>
                            </div>


                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark class="ma-2" color="primary" title="Guardar" @click="guardar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <v-btn dark class="ma-2" color="#FF4081" title="Cancelar" @click="cancelar()"
                                :disabled="disabledSave">
                                <span style='color: white;'>Cancelar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import moment from 'moment';
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            messageFirma: '',
            errorFirma: false,
            maxDate: '',
            minDate: '',
            fechaResp: '',
            modal: false,
            disabledSave: false,
            validForm: true,
            tipoNegociacion: '1',
            datos: {
                ngid: null,
                tipoNegociacionname: null,
                montoestimadodanos: null,
                responsabilidadAse: '1',
                responsabilidadname: '',
                montoneg: null,
                responsabilidad: null,
                montoacuerdo: null,
                respneg: null,
                observacionesAutoriza: null,
                formaRecuperacion: null,
                montorango: null,
                fecharespuesta: null,
                firma: '',
                observaciones: null
            },
            formaArray: [
                {
                    value: null,
                    label: 'Seleccionar opción'
                },
                {
                    value: 1,
                    label: 'Efectivo'
                },
                {
                    value: 2,
                    label: 'Cheque'
                },
                {
                    value: 3,
                    label: 'Documento'
                }
            ],
            rulesMontoAse: [(v) => {
                if (v == null || v == '') {
                    return 'Inserte un valor valido';
                }
                //else if (v.length > 8) {
                //    return 'Inserte un valor valido';
                //}
                else {
                    var d = v.split("/");
                    if (parseInt(d[0]) < 100 || parseInt(d[1]) < 100) {
                        return 'El valor del rango debe ser mayor a 100';
                    }
                    if (parseInt(d[0]).toString().length > 8 || parseInt(d[1]).toString().length > 8) {
                        return 'El valor del rango debe tener menos de 8 dígitos';
                    }
                    //return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                }
                return true
            }],
            rulesselect: [v => !!v || 'Seleccione una opción'],
            rulesradios: [v => !!v || 'Seleccione una opción'],
            rulestextfechas: [v => !!v || 'Campo requerido'],
            rulestextarea: [//v => !!v || 'Campo requerido',
                v => {
                    if (v == null || v == '') {
                        return 'Campo requerido'
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            push: 0,
            displayInputs: {
                d3id: 0
            },
        }
    },
    watch: {
        'datos.fecharespuesta'(val) {
            this.fechaResp = val;
        },
        'datos.respneg'(val) {
            this.datos.observacionesAutoriza = null;
            this.datos.formaRecuperacion = null;
            this.datos.montorango = null;

        },
        'datos.firma'(val) {
            if (val == null || val == '') {
                this.errorFirma = true;
            }
            else {
                if (val.length < 8 || val.length > 16) {
                    this.errorFirma = true;
                }
                else
                    this.errorFirma = false;
            }
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        ruleMoney: function ($event, value) {
            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (value.includes('/')) {
                    if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }
                else {
                    if (($event.charCode >= 47 && $event.charCode <= 57) || $event.charCode == 46) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }


            }
        },
        async guardaDatos() {
            this.$swal({
                position: 'center',
                title: 'Guardando respuesta ...',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            await Reporte.insertarRespuestaNegociacion(this).then(response => {
                setTimeout(() => {
                    this.$swal.close();
                    if (response) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Adjuntar Soportes de la Respuesta a la Negociación',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.cancelar();
                            }
                        });
                        setTimeout(() => {
                            this.$swal.close();
                            this.cancelar();
                        }, 3000);

                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Hubo un error al guardar la respuesta, Favor de avisar a Desarrollo',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                    }

                }, 2000);


            });


        },
        async guardar() {
            this.disabledSave = true;
            this.$refs.form.validate();
            let error = 0;
            if (this.datos.firma.length == 0) {
                this.messageFirma = 'Para dar respuesta a la Negociación es necesario ingresar su firma';
                this.errorFirma = true;
                error++;
            }
            if (this.datos.firma.length < 8 && this.datos.firma.length > 0) {
                this.messageFirma = 'Firma electrónica avanzada debe tener un mínimo de 8 y menor a 17 carácteres';
                this.errorFirma = true;
                error++;
            }


            if (this.$refs.form.validate() && error == 0) {
                await Reporte.valFirmaElectronica(this).then(response => {
                    if (response == 1) {
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            title: 'Firma electrónica incorrecta',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.disabledSave = false;

                    }
                    else {
                        this.guardaDatos();
                    }
                });
            }
            else {
                this.disabledSave = false;
            }




        },
        cancelar() {
            if (this.push == 0) {
                this.push++;
                this.$router.go(-1);
            }

        },
        uppercase(input) {
            if (input == 'observaciones') {
                if (this.datos.observaciones != '' && this.datos.observaciones != null) {
                    this.datos.observaciones = this.datos.observaciones.toUpperCase();
                }
            }
            if (input == 'observacionesAutoriza') {
                if (this.datos.observacionesAutoriza != '' && this.datos.observacionesAutoriza != null) {
                    this.datos.observacionesAutoriza = this.datos.observacionesAutoriza.toUpperCase();
                }
            }

        },
    },
    async mounted() {
        let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
        if (clavetercero.d3id == undefined) {
            this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            return
        }
        this.changeReporteMenuOption(clavetercero.urlname);
        this.displayInputs = {
            d3id: clavetercero.d3id
        };
        await Reporte.obtenerEstatusListado(this).then(response => {
            if (this.validaConclusion
                || response.data[0].ConclusionDanosLes != 0
                || response.data[0].Estatus != 2
                || !response.data[0].permisoRespNegociacion) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }

        });


        await Reporte.obtenerDatosNegociacionValidacion(this).then(response => {
            this.datos.montoestimadodanos = response.data[0].svestdanosveh;
            this.datos.tipoNegociacionname = response.data[0].tipoNegociacionname;
            this.datos.responsabilidadname = response.data[0].svresponsable;
            this.datos.montoneg = response.data[0].ngmonto;
            this.datos.montoacuerdo = response.data[0].Montodanios;
            this.datos.responsabilidad = response.data[0].Responsabilidad;
            this.datos.ngid = response.data[0].ngid;

            this.maxDate = response.data[0].today;
            this.datos.fecharespuesta = response.data[0].today;
            this.fechaResp = response.data[0].today;

            this.minDate = response.data[0].svfhreporte;

        });

    }
}
</script>

<style>
.date-align-center .v-input input {
    text-align: center !important;
}
</style>
<style scoped>
.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 12px;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}
</style>